export function ReportFormSubmitBtn() {
    return (
        <button
            className={`bg-[#FF892A] w-full rounded-lg text-white py-3`}
            type="submit"
        >
            送出檢舉
        </button>
    )
}
